import PhoneInput from 'react-phone-input-2'
import ru from 'react-phone-input-2/lang/ru.json'
import React from 'react'
import 'react-phone-input-2/lib/bootstrap.css'
import './index.less'

import { COUNTRIES_CODE } from '../../constants/countries'


/**
 * Phone component with select prefix country and validation.
 */
export default class PhoneInputComponent extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.phoneInputRef = React.createRef(null)
    this.nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set
    this.state = {
    }
  }

    triggerChange = (values) => {
      const { onChange } = this.props
      if (onChange) {
        onChange({
          ...values,
        })
      }
    };

    handlePhoneNumberChange = (number, country, e, formattedValue) => {
      //  "validator" library has special format for country code, we need to change to correct validation.
      const formattedCountryCode = COUNTRIES_CODE.find(code => code.slice(code.indexOf('-') + 1).toLowerCase() === country.countryCode)
      const formattedNumber = number.slice(number.indexOf(country.dialCode) + country.dialCode.length)
      this.triggerChange({
        number: formattedNumber,
        prefix: country.dialCode,
        country: {
          ...country,
          countryCode: formattedCountryCode,
        },
      })
    };


    render() {
      const { number, prefix } = this.props.value
      const { error } = this.props
      return (
        <PhoneInput
          inputStyle={{fontSize: 14, height: 38}}
          localization={ru}
          preferredCountries={['ru', 'ro']}
          searchPlaceholder='Поиск страны'
          searchNotFound='Ничего не найдено'
          enableSearch
          countryCodeEditable={false}
          onChange={this.handlePhoneNumberChange}
          placeholder='Введите номер телефона'
          country='ru'
          value={`${prefix}${number}`}
          isValid={() => !error}
        />
      )
    }
}



// WEBPACK FOOTER //
// src/components/PhoneInputComponent/index.jsx